// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mk-0";